module.exports = __webpack_public_path__ + "media/images/pic/hero/trees-58ea34c9d8cc53d36d0ddaa990e98310.webp";